import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconTextToSpeach: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconTextToSpeach"><Path fillRule="evenodd" clipRule="evenodd" d="M15 7V21H13.5V7H15ZM18.5 10V18H17V10H18.5ZM22 12V16H20.5V12H22ZM11.5 14V18H10V14H11.5Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M2 3H12V6H10.5V4.5H7.75V11.5H9.5V13H4.5V11.5H6.25V4.5H3.5V6H2V3Z" fill="currentColor"/></CentralIconBase>;
});

export default IconTextToSpeach;
